import { useMutation } from '@tanstack/react-query'

import { httpService } from '@/api/v1/http.service'

const useRemoveCurriculums = ({
  onSuccess,
  onError
}: {
  onSuccess: (data: {
    successfully_deleted: number
    unsuccessfully_deleted: number
  }) => void
  onError: () => void
}) =>
  useMutation({
    mutationFn: (ids: string[]) =>
      httpService.panel.panelCurriculumsBulkDeleteCreate({
        curriculums_ids: ids
      }),
    onSuccess,
    onError
  })

export default useRemoveCurriculums
